import "htmx.org";

import { Carousel } from "./components/carousel.ts";
import { FieeChat } from "./components/chat.ts";
import { FieeClock } from "./components/clock.ts";
import { DevReload } from "./components/dev-reload.ts";
import { FieeDialog } from "./components/dialog.ts";
import { FieeIdle } from "./components/idle.ts";
import { FieeLightbox } from "./components/lightbox.ts";
import { FieeMap } from "./components/map.ts";
import { initNavToggle } from "./components/nav.ts";
import { FieeRichText } from "./components/rich-text.ts";
import { FieeToast } from "./components/toast.ts";

// Register the interactive islands. Each is a self-contained Web Component that
// hydrates wherever its custom element appears in the server-rendered HTML.
customElements.define("fiee-clock", FieeClock);
customElements.define("fiee-carousel", Carousel);
customElements.define("fiee-toast", FieeToast);

// Shared by the public site and the admin panel: the /mallas image viewer and
// the rich-text editor of the plan forms.
customElements.define("fiee-lightbox", FieeLightbox);
customElements.define("fiee-rich-text", FieeRichText);

// Kiosk (/panel): the shared dialog, the idle reset, the campus map and the
// streamed assistant chat.
customElements.define("fiee-dialog", FieeDialog);
customElements.define("fiee-idle", FieeIdle);
customElements.define("fiee-map", FieeMap);
customElements.define("fiee-chat", FieeChat);

// <fiee-dev-reload> is only rendered when APP_ENV=dev, so in production the
// element never appears and this component stays dormant.
customElements.define("fiee-dev-reload", DevReload);

// Public site: mobile navigation toggle.
document.addEventListener("DOMContentLoaded", () => {
  initNavToggle();
});
